export function fakePromisePrototype(props) {
    return new Promise((resolve, reject) => {
        setTimeout(() => {
            if (props?.force_error)
                return reject(props.error_options || {});
            return resolve(props?.successReturn || true);
        }, props?.delay || 400);
    });
}
//# sourceMappingURL=fakePromise.js.map